const configApiService = {
  base_url: process.env.VUE_APP_ENDPOINT
  //base_url: 'https://api-ime.k0s.ime.red',
}
  
export default configApiService